import { checkIfAnswerIsSelected } from "@/helpers/screenerCheckIfAnswered"

export default {
  getActiveSectionRefs(state) {
    const sections = state.survey?.sections || []
    let sectionRefs = []

    for (const section of sections) {
      for (const question of section.questions) {
        for (const answer of question.answers) {
          if (checkIfAnswerIsSelected(answer, question.type)) {
            if (answer.sectionRef) {
              sectionRefs.push(answer.sectionRef)
            }
            if (answer.embeddedQuestion) {
              for (const answerEmbedded of answer.embeddedQuestion.answers) {
                if (checkIfAnswerIsSelected(answerEmbedded, answer.embeddedQuestion.type)) {
                  if (answerEmbedded.sectionRef) {
                    sectionRefs.push(answerEmbedded.sectionRef)
                  }
                  if (answerEmbedded.embeddedQuestion) {
                    for (const answerEmbeddedEmbedded of answerEmbedded.embeddedQuestion.answers) {
                      if (checkIfAnswerIsSelected(answerEmbeddedEmbedded, answerEmbedded.embeddedQuestion.type) && answerEmbeddedEmbedded.sectionRef) {
                        sectionRefs.push(answerEmbeddedEmbedded.sectionRef)
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return sectionRefs
  }
}